"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactI18next = require("react-i18next");
var _store = require("../../../../redux/store");
var _popupSlice = require("../../../../redux/popupSlice");
var _checkmarkBase = _interopRequireDefault(require("../../../../assets/images/checkmarkBase"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _InnerPopupWrapperStyled = require("../../../InnerPopupWrapper/InnerPopupWrapperStyled");
var _SwitchPlanPopupStyled = require("../../../SwitchPlanPopup/SwitchPlanPopupStyled");
var _jsxRuntime = require("react/jsx-runtime");
const FreeExtensionConfirmation = () => {
  const dispatch = (0, _store.useAppDispatch)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SwitchPlanPopupStyled.ImageWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SwitchPlanPopupStyled.ImageStyled, {
          src: _checkmarkBase.default,
          alt: "checkmark icon"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
        children: t('free-extension.success.header', 'Thank You!')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
        children: t('free-extension.success.description', 'You have successfully extended your plan')
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        theme: "confirm",
        onClickFn: () => dispatch((0, _popupSlice.hidePopup)()),
        children: t('free-extension.success.back-button', 'Back to My Account')
      })
    })]
  });
};
var _default = exports.default = FreeExtensionConfirmation;